import React, {Component} from 'react'
import {MaterialReactTable} from 'material-react-table'
import { Container, Row, Col, Card, CardBody, Media, Button,
  Modal, ModalHeader, ModalBody, ModalFooter, TabPane,
} from 'reactstrap'
import { selectValues, getRegs, insert, update, insOrUp, getDocs, getRegValue, getReg } from '../../../utils/fc'
import Switch from '@mui/material/Switch'


class DBSwitch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false,
    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async () => {
    console.log("getRegValue = ", await getRegValue("pf",3,"pf_nome"))
    console.log("getReg = ", await getReg("pf",3))
    this.setState({checked: this.props.checked})
  }

  render() {
    const label = { inputProps: { 'aria-label': 'Size switch demo' } };
    const {checked} = this.state
    return (
      <Switch
        {...label}
        checked={this.props.checked}
        size="small"
        onChange={() => this.setState({checked: !checked})}
      />
    )
  }
}
export default DBSwitch
